
import { Component, Vue, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component
export default class DateMethods extends Mixins(LocalizationMethods) {
    public handleFormatedDate(passedDate: any, type: string = 'YYYY-MM-DD', todayCheck: boolean = false, fromFormat: string = '', local: boolean = false) {
        if (!passedDate) {
            return '';
        } else {
            const acceptedDate = typeof passedDate.date === 'undefined' ? passedDate : passedDate.date;

            if (todayCheck) {
                return moment().isSame(passedDate, 'day') ? `${this.$t('general.today', 'Today')}` : moment(acceptedDate).format(type);
            }

            return fromFormat !== ''
                ? (local ? moment(acceptedDate, fromFormat).local().format(type) : moment(acceptedDate, fromFormat).format(type))
                : (local ? moment(acceptedDate).local().format(type) : moment(acceptedDate).format(type));
        }
    }

    public localizedTime(passedDate: string, format: string = 'YYYY-MM-DD') {
        const dateUtc = moment.utc(passedDate);

        return moment(dateUtc).local().format(format);
    }

    public getFormattedCalenderDay(date: string): string {
        const momentObj = this.$moment(date).locale(this.currentLocalizationKey);
        return momentObj.calendar();
    }

    public created() {
        const localizationKey = this.$store.getters['Localization/getLocalizationKey'];
        moment.locale(localizationKey);
    }

    // Timestamps
    // -----------------------------------------

    public getCurrentLocalTimeStamp() {
        return this.$moment().format();
    }

    public getCurrentUTCTimeStamp() {
         return this.$moment.utc().format();
    }


    // UTC -> UTC
    // -----------------------------------------

    // Return a moment object that assumes input is utc
    public parseAsUtcString(utcDateString: string | null) {
        return this.$moment.utc(utcDateString);
    }

    // Converts a string that is not specified as utc to the same time in utc notation
    // It assumes that the string parsed is alreay utc
    public getUTCISOstring(utcDateString: string | null) {
        const dateObject = this.parseAsUtcString(utcDateString);
        return dateObject.isValid() ? dateObject.toISOString() : null;
    }

    // Parses a string to dateTime format based on UTC time
    public getUTCDateTimeString(utcDateString: string | null) {
        const dateObject = this.parseAsUtcString(utcDateString);
        return dateObject.isValid() ? dateObject.format('YYYY-MM-DD HH:mm') : null;
    }

    // Parses a string to date format based on UTC time
    public getUTCDateString(utcDateString: string | null) {
        const dateObject = this.parseAsUtcString(utcDateString);
        return dateObject.isValid() ? dateObject.format('YYYY-MM-DD') : null;
    }

    public getUnixTime(utcDateString: string | null) {
        const dateObject = this.parseAsUtcString(utcDateString);
        return dateObject.unix();
    }


    // Local -> UTC
    // -----------------------------------------

    // Parses a string to ISO8601 based on current timezone
    public convertLocalTimeToISOString(localDateString: string | null) {
        const dateObject = this.$moment(localDateString);
        return dateObject.isValid() ? dateObject.toISOString() : null;
    }


    // UTC -> Local
    // -----------------------------------------

    // Return a moment object that assumes input is local if utc or offset is not specified
    public parseAsLocalDateTimeString(utcDateString: string | null) {
        return this.$moment(utcDateString).locale(this.currentLocalizationKey);
    }

    // Parses a string to ISO8601 with time offset based on current timezone
    public getLocalUTCOffsetString(utcDateString: string | null, format: string = null) {
        // Used to make sure non utc value from server is always parsed as utc
        const utcIsoString = this.getUTCISOstring(utcDateString);
        const dateObject = this.parseAsLocalDateTimeString(utcIsoString);
        return dateObject.isValid() ? dateObject.format(format) : null;
    }

    // Parses a string to dateTime format based on current timezone
    public getLocalDateTimeString(utcDateString: string | null) {
        return this.getLocalUTCOffsetString(utcDateString, 'YYYY-MM-DD HH:mm');
    }

    // Parses a string to date format based on current timezone
    public getLocalDateString(utcDateString: string | null) {
        return this.getLocalUTCOffsetString(utcDateString, 'YYYY-MM-DD');
    }

    // Parses a string to time format based on current timezone
    public getLocalTimeString(utcDateString: string | null) {
        return this.getLocalUTCOffsetString(utcDateString, 'HH:mm');
    }
}
